<template>
    <div>
        <div class="flex items-center mt-3 mb-3 w-full">
            <div>
                <i class="fad fa-user-md"></i>
                <span class="font-bold mr-1">Baan:</span>
            </div>
            <div class="flex flex-1  px-2 rounded items-center">
                <i class="fad mr-1" :class="loading === 'applyTemplate' ? 'fa-spinner fa-spin' : 'fa-plus-circle'"></i>
                <v-select v-model="jobtemplate" 
                    :close-on-select="true" 
                    :options="Object.values(options)" 
                    :clearable="false"
                    label="title" 
                    class="w-full bg-white" 
                    @input="select()" 
                    ref="select"
                    >
                    <template v-slot:option="option">
                        <div class="truncate">
                            <i class="fal" :class="option.categoryIcon"></i>
                            {{ option.title }}
                        </div>
                    </template>
                </v-select>
            </div>
        </div>
    </div>
</template>

<script>

// import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import hotkeys from "hotkeys-js";

export default {

    components: { vSelect },
    
    props: {
        options: Array,
        selected: '',
        loading: ''
    },

    data() {
        return {
            jobtemplate: "",
        };
    },

    methods: {
        
        select() {
            if(this.jobtemplate && this.jobtemplate.id){
                this.$emit("select", this.jobtemplate);
            }
        },
    },

     mounted() {
        this.jobtemplate = this.selected
        hotkeys.filter = function(event){
            return true;
        }
        const select = this.$refs.select.$refs.search;
        hotkeys("cmd+2", function(event, handler) {
            event.preventDefault();
            select.focus();
            return false
        });
        
    }
};
</script>


<style scope="scoped">
    .v-select .vs__selected-options {
        flex-wrap: wrap;
    }
    .v-select .vs__dropdown-menu li {
        @apply px-2;
    }
</style>